var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.formData.id ? "编辑业务类型" : "新增业务类型",
            top: "5vh",
            width: "720px",
            "destroy-on-close": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                "label-width": "120px",
                model: _vm.formData,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "业务类型：", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择业务类型",
                        clearable: "",
                        disabled: _vm.isEditMode,
                      },
                      on: { change: _vm.handleTypeChange },
                      model: {
                        value: _vm.formData.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "type", $$v)
                        },
                        expression: "formData.type",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "实物", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "团购", value: 2 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "酒店", value: 3 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "divider-line" }),
              _vm._v(" "),
              _vm._l(_vm.formData.storeTypes, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "store-type-item" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label:
                            "店铺类型" +
                            (_vm.formData.storeTypes.length > 1
                              ? index + 1
                              : "") +
                            "：",
                          prop: "storeTypes." + index + ".name",
                          rules: [
                            {
                              required: true,
                              message: "请输入店铺类型",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "input-with-buttons" },
                          [
                            _c("el-input", {
                              staticClass: "store-type-input",
                              attrs: {
                                clearable: "",
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: item.name,
                                callback: function ($$v) {
                                  _vm.$set(item, "name", $$v)
                                },
                                expression: "item.name",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "action-buttons" },
                              [
                                index === _vm.formData.storeTypes.length - 1
                                  ? _c("el-button", {
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-plus",
                                        size: "small",
                                        circle: "",
                                      },
                                      on: { click: _vm.handleAddStoreType },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.storeTypes.length > 1
                                  ? _c("el-button", {
                                      attrs: {
                                        type: "danger",
                                        icon: "el-icon-minus",
                                        size: "small",
                                        circle: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleRemoveStoreType(
                                            index
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isGroupBuyType
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                "页面展示类型" +
                                (_vm.formData.storeTypes.length > 1
                                  ? index + 1
                                  : "") +
                                "：",
                              prop: "storeTypes." + index + ".pageDisplayType",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择页面展示类型",
                                  clearable: "",
                                  loading: _vm.pageDisplayTypeLoading,
                                },
                                model: {
                                  value: item.pageDisplayType,
                                  callback: function ($$v) {
                                    _vm.$set(item, "pageDisplayType", $$v)
                                  },
                                  expression: "item.pageDisplayType",
                                },
                              },
                              _vm._l(
                                _vm.pageDisplayTypeOptions,
                                function (option) {
                                  return _c("el-option", {
                                    key: option.value,
                                    attrs: {
                                      label: option.label,
                                      value: option.value,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label:
                            "排序" +
                            (_vm.formData.storeTypes.length > 1
                              ? index + 1
                              : "") +
                            "：",
                          prop: "storeTypes." + index + ".sort",
                        },
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            min: 0,
                            precision: 0,
                            placeholder: "请输入排序",
                          },
                          model: {
                            value: item.sort,
                            callback: function ($$v) {
                              _vm.$set(item, "sort", $$v)
                            },
                            expression: "item.sort",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label:
                            "店铺logo" +
                            (_vm.formData.storeTypes.length > 1
                              ? index + 1
                              : "") +
                            "：",
                          prop: "storeTypes." + index + ".icon",
                          rules: [
                            {
                              required: true,
                              message: "请上传店铺logo",
                              trigger: "change",
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "upload-container" },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  action: "#",
                                  "show-file-list": false,
                                  "http-request": function (param) {
                                    return _vm.handleUpload(param, index)
                                  },
                                  "before-upload": _vm.beforeUpload,
                                },
                              },
                              [
                                item.icon
                                  ? _c(
                                      "div",
                                      { staticClass: "avatar-container" },
                                      [
                                        _c("img", {
                                          staticClass: "avatar",
                                          attrs: { src: item.icon },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "avatar-cover" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-delete",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.handleRemoveImage(
                                                    index
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "avatar-uploader-icon" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-plus",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "upload-text" },
                                          [_vm._v("图片")]
                                        ),
                                      ]
                                    ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "miniapp-customer-block" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "miniapp-customer-item",
                            attrs: {
                              label: "关联小程序客户：",
                              prop:
                                "storeTypes." + index + ".relatedCustomerType",
                              rules: [
                                {
                                  required: true,
                                  message: "请选择关联范围",
                                  trigger: "change",
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { size: "small" },
                                on: {
                                  change: function (val) {
                                    return _vm.onStoreRelatedCustomerTypeChange(
                                      index,
                                      val
                                    )
                                  },
                                },
                                model: {
                                  value: item.relatedCustomerType,
                                  callback: function ($$v) {
                                    _vm.$set(item, "relatedCustomerType", $$v)
                                  },
                                  expression: "item.relatedCustomerType",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("全部"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("部分"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        item.relatedCustomerType === 0
                          ? _c(
                              "el-form-item",
                              {
                                staticClass: "miniapp-customer-select",
                                attrs: {
                                  label: " ",
                                  prop: "storeTypes." + index + ".customerIds",
                                  rules: _vm.getCustomerIdsRules(index),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass:
                                      "miniapp-customer-select__input",
                                    attrs: {
                                      placeholder: "请选择关联小程序",
                                      multiple: "",
                                      filterable: "",
                                      remote: "",
                                      clearable: "",
                                      "remote-method":
                                        _vm.searchCustomerOptions,
                                      loading: _vm.customerLoading,
                                    },
                                    model: {
                                      value: item.customerIds,
                                      callback: function ($$v) {
                                        _vm.$set(item, "customerIds", $$v)
                                      },
                                      expression: "item.customerIds",
                                    },
                                  },
                                  _vm._l(
                                    _vm.customerOptions,
                                    function (option) {
                                      return _c("el-option", {
                                        key: option.customerId,
                                        attrs: {
                                          label: option.appName,
                                          value: option.customerId,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }